/* eslint-disable */

import _ from 'lodash';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createFilterOptions } from "@mui/material";
import { useFormState } from "react-final-form";
import QCXAutocompleteSelect from "../autocomplete-select/QCXAutocompleteSelect";
import { selectTarifa,fetchAllAsync } from "../../features/tarifa/tarifaSlice";

export default function QCXSelectTarifaAutocomplete({
    label, 
    name, 
    initialValues, 
    defaultCode, 
    ...restProps}) {

    const dispatch = useDispatch();
    const list = useSelector(selectTarifa);
    
    useEffect(() => {
      if (list.length === 0) {
        dispatch(fetchAllAsync());
      }
    }, []);
  
    const { initialValues: formInitialValues } = useFormState();
    const localInitialValues = useMemo(() => initialValues || formInitialValues, [initialValues, formInitialValues]);
  
    const [defaultValue, setDefaultValue] = useState('');
    
    useEffect(() => {
      const defaultMoeda = list?.find((m) => m.id === defaultCode);
      if (defaultMoeda && defaultValue !== defaultMoeda) {
        setDefaultValue(defaultMoeda);
        return;
      }
    
      const value = list.find((item) => item.id === Number(_.get(localInitialValues, name)));
    
      if (value && defaultValue !== value) {
        setDefaultValue(value);
      } else if (!value && defaultValue.id !== null) {
        setDefaultValue({ id: null, description: '' });
      }
    }, [list, localInitialValues, name, defaultCode, defaultValue]);
    
    const filterOptions = createFilterOptions({
      stringify: (option) => `${option.id} - ${option.description}`,
    });

    return (
         <QCXAutocompleteSelect
            label={label}
            id={name}
            name={name}
            options={list}
            filterOptions={filterOptions}
            defaultValue={defaultValue}
            getOptionLabel={(item) => (item?.id && item?.description ? `${item?.id} - ${item?.description}` : '')}
            {...restProps}
        />
    );
}